var _rect, _line, _line2, _polygon, _path, _rect2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDeviceChargingStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.92,
    y: 3.049,
    width: 16.372,
    height: 29.759,
    rx: 2.063,
    ry: 2.063
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.293,
    y1: 29.396,
    x2: 4.337,
    y2: 29.396
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.293,
    y1: 6.734,
    x2: 4.337,
    y2: 6.734
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.011 26.623 12.009 19.081 8.381 19.081 14.659 8.807 12.743 16.553 16.249 16.553 10.011 26.623"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.106,33.233v3.726c0,1.1.891,1.991,1.991,1.991h16.125c1.828,0,3.31-1.482,3.31-3.31v-16.688"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.781,
    y: 8.653,
    width: 11.505,
    height: 9.093,
    transform: "translate(20.333 46.733) rotate(-90)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.008,
    y1: 3.212,
    x2: 31.008,
    y2: 7.164
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35.944,
    y1: 3.212,
    x2: 35.944,
    y2: 7.164
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDeviceChargingStation);
export default __webpack_public_path__ + "static/media/indoor-device_charging_station.e89ff4cba632f6915022677f46e4575f.svg";
export { ForwardRef as ReactComponent };